import { render, staticRenderFns } from "./InputFormElement.component.vue?vue&type=template&id=e9814b94"
import script from "./InputFormElement.component.vue?vue&type=script&lang=js"
export * from "./InputFormElement.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports